module.exports = __webpack_public_path__ + "static/img/aigc-check-tip.85be8b56.png";